import React from 'react';

interface ICampAlliesLvlBarProps {
    allyLvl: number
    allyMaxLvl: number
}

const CampAlliesLvlBar = ({ allyLvl, allyMaxLvl }: ICampAlliesLvlBarProps) => {

    const progress = (allyLvl / allyMaxLvl) * 100

    return (
        <div className="info__content-lvlbar lvlbar">
            <div className='lvlbar__progress' style={{ width: `${progress}%` }}>
                <span>Max lvl ally: {allyMaxLvl}</span>
            </div>
        </div>
    );
};

export default CampAlliesLvlBar;